import React from 'react'
import { AccessLog } from '@/presentation/pages/AccessLog'
import { makeGetAccessLog } from '@/main/factories/usecases'

export const makeAccessLogFactory = (): JSX.Element => {
  return (
    <AccessLog getAccessLog={makeGetAccessLog()} />
  )
}
